<template>
  <!-- payment modal -->
  <div class="inset-0 z-[110] w-full bg-[#2b2b2b8e]">
    <transition name="dropdown">
      <!-- modal contnet-->
      <div
        class="fixed left-[50%] top-[50%] z-[120] flex w-[90%] max-w-[400px] translate-x-[-50%] translate-y-[-50%] flex-col gap-8 overflow-hidden rounded-lg bg-gray-200 px-3 py-3 sm:w-full"
        style=""
      >
        <h1
          autofocus="false"
          aria-selected="false"
          class="mx-auto w-full border-b-2 border-[#000000] px-1 py-2 text-center font-extrabold text-[#000000] [font-size:_clamp(.7em,2vw,1em)] sm:w-[70%]"
        >
          {{ $t("general.choose_payment_method") }}
        </h1>
        <section class="mt-5 grid gap-6">
          <!-- Cart -->
          <div class="relative">
            <input v-model="paymentMethod" value="card" class="peer hidden" id="radio_1" type="radio" name="radio" checked />
            <label
              class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
              for="radio_1"
            >
              <img class="w-14 object-contain" src="@/assets/upgrade/visa.png" alt="" />
              <div class="mr-5 ltr:ml-5 ltr:mr-0">
                <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                <p class="text-sm leading-6 text-slate-500">Visa</p>
              </div>
            </label>
          </div>

          <!-- Mobile wallet -->
          <div class="relative">
            <input v-model="paymentMethod" value="mobile_wallet" class="peer hidden" id="radio_2" type="radio" name="radio" />
            <label
              class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
              for="radio_2"
            >
              <img class="w-14 object-contain" src="@/assets/upgrade/wallet.png" alt="" />
              <div class="mr-5 ltr:ml-5 ltr:mr-0">
                <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                <p class="py-2 text-sm leading-6 text-slate-500">Mobile wallet</p>
              </div>
            </label>
          </div>
           <!-- phone -->
           <div v-if="paymentMethod == 'mobile_wallet'">
            <input
              v-model="phone"
              maxlength="11"
              type="tel"
              @input="(e) => (phone = e.target.value.replace(/\D/g, ''))"
              :class="`mt-2 w-full bg-[#FFFFFF] ${v$.phone.$errors.length ? 'border-[#ed0d0d]' : 'border-[#D8D8D8]'} block rounded-[7px] border p-2.5 pr-3 text-sm text-gray-900 outline-none placeholder:text-[#bebebe] focus:border-blue-500 ltr:text-inherit rtl:text-end`"
              :placeholder="$t('user.store.phone_number')"
            />
            <p v-for="(error, index) of v$.phone.$errors" :key="error.uid" class="mt-1 pr-2 text-sm text-red-600 ltr:pl-2 ltr:pr-0">
              {{ index == 0 ? error.$message : "" }}
            </p>
          </div>

          <!-- Cezma wallet- credit wallet -->
          <div v-if="!isUser" class="relative">
            <input v-model="paymentMethod" value="credit_wallet" class="peer hidden" id="radio_3" type="radio" name="radio" />
            <label
              class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
              for="radio_3"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="56px" height="56px" viewBox="0 0 48 48">
                <g fill="none">
                  <rect
                    width="38"
                    height="26"
                    x="5"
                    y="13"
                    fill="#2f88ff"
                    stroke="#000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="4"
                    rx="2"
                  />
                  <rect width="18" height="11" x="25" y="20" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" />
                  <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M43 18L43 33" />
                  <path
                    stroke="#000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="4"
                    d="M32 13C32 8 28.5 7 27 7C23.6667 7 16.1 7 12.5 7C8.9 7 8 9.86567 8 11.2985V13"
                  />
                  <circle cx="33.5" cy="25.5" r="1.5" fill="#fff" />
                </g>
              </svg>
              <div class="mr-5 ltr:ml-5 ltr:mr-0">
                <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                <p class="py-2 text-sm leading-6 text-slate-500">Cezma wallet</p>
              </div>
            </label>
          </div>

         
        </section>

        <section class="flex flex-row justify-around font-semibold text-white [font-size:_clamp(.7em,2vw,.9em)]">
          <button
            @click="checkout"
            :disabled="isProcessing"
            class="w-[80%] rounded-md bg-[#0963FF] px-1 py-2 text-center hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:bg-blue-900 dark:focus:ring-blue-900 sm:w-[40%]"
          >
            {{ isProcessing ? $t("general.loading") : ` ➔ ${$t("general.continue_payment")}` }}
          </button>
          <!-- <button class="bg-[#0963FF] py-2 px-1 w-[30%] text-center rounded-md">تخطي الكل</button> -->
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import Multiselect from "vue-multiselect";
import { useGlobalStore } from "@/store/Modules/global";

export default {
  name: "PaymentPopup",
  props: {
    checkout: {
      type: Function,
      required: false,
      default: () => {},
    },
    isProcessing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      v$: useVuelidate(),
      showPaymentModal: false,
      paymentMethod: "card", //mobile_wallet
      phone: "",
    };
  },
  validations() {
    return { phone: { ...this.VALIDATIONS.phone } };
  },
  components: {
    Multiselect,
  },
  computed: {
    isUser() {
      const global = useGlobalStore();
      return global?.currentUserRole == "user";
    },
  },
  methods: {
    preCheckout() {
      this.paymentMethod == "mobile_wallet" && this.v$.$touch();
      if (this.paymentMethod == "mobile_wallet" && this.v$.phone.$error) return;
      this.checkout({ paymentMethod: this.paymentMethod, phone: this.phone });
    },
   
  },
};
</script>

<style lang="scss"></style>
